module.exports = __webpack_public_path__ + "static/media/yt.a1387f1c.svg";